(() => {
  if (customElements.get('hamilton-editorial-media')) return;
  class HamiltonEditorialMedia extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.videos = [...this.querySelectorAll('video')];
      this.button = this.querySelector('[data-media-toggle]');
      this.mobile = matchMedia('(max-width:749px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.paused = this.reduced.matches || !!window.Shopify?.designMode;
      this.inView = false;
      this.manualPlay = false;
      const on = (node, event, handler) => node?.addEventListener(event, handler, {signal:this.abort.signal});
      on(this.button, 'click', () => { this.paused = !this.paused; this.manualPlay = true; this.sync(); });
      on(document, 'visibilitychange', () => this.sync());
      on(this.mobile, 'change', () => this.sync());
      on(this.reduced, 'change', () => { this.manualPlay = false; if(this.reduced.matches) this.paused = true; this.sync(); });
      this.observer = new IntersectionObserver(entries => {this.inView = entries[0].isIntersecting;this.sync();}, {threshold:.15});
      this.observer.observe(this);
      this.sync();
    }
    canPlay() { return this.inView && !document.hidden && !this.paused && (!this.reduced.matches || this.manualPlay); }
    sync() {
      this.videos.forEach(video => {
        const visible = video.classList.contains(this.mobile.matches ? 'hamilton-home-hero__mobile' : 'hamilton-home-hero__desktop');
        if(visible && this.canPlay()) video.play()?.catch(() => {if(this.isConnected){this.paused = true; this.sync();}});
        else video.pause();
      });
      if(this.button) {
        this.button.textContent = this.paused ? '▷' : 'Ⅱ';
        this.button.setAttribute('aria-label',this.paused ? 'Reproducir video' : 'Pausar video');
        this.button.setAttribute('aria-pressed',String(this.paused));
      }
    }
    disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();this.videos?.forEach(video => video.pause());}
  }
  customElements.define('hamilton-editorial-media',HamiltonEditorialMedia);
})();
